import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { blogPosts } from "@/data/blogPosts";

export default function BlogPost() {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);
  if (!post) return <Navigate to="/blog" replace />;

  const others = blogPosts.filter((p) => p.slug !== slug).slice(0, 2);

  return (
    <div data-testid="blog-post-page">
      <article className="border-b border-border">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <Link to="/blog" data-testid="blog-back-link" className="inline-flex items-center gap-1.5 text-sm font-bold text-muted-foreground hover:text-[#FF5A00] transition-colors">
            <ArrowLeft size={15} /> All articles
          </Link>
          <span className="block text-xs font-bold uppercase tracking-widest text-[#FF5A00] mt-8">{post.category}</span>
          <h1 className="font-heading font-extrabold tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl mt-3">{post.title}</h1>
          <p className="text-sm text-muted-foreground mt-4">{post.date} · {post.readTime}</p>
          <img src={post.image} alt={post.title} className="w-full h-64 sm:h-80 object-cover mt-8 border border-border" />
          <div className="mt-10 space-y-6">
            {post.content.map((para, i) => (
              <p key={i} className="text-base leading-relaxed text-foreground/85">{para}</p>
            ))}
          </div>
          <div className="mt-12 border border-[#FF5A00] bg-[#FFF3ED] p-8">
            <h3 className="font-heading font-extrabold text-xl">Ready to hand off your books?</h3>
            <p className="text-sm text-muted-foreground mt-2">Bookkeeping from $9.99/hour with a 1-week free trial. No contracts.</p>
            <Link
              to="/appointment"
              data-testid="blog-post-cta"
              className="inline-flex items-center gap-2 bg-[#FF5A00] hover:bg-[#E04F00] text-white font-bold px-6 py-3 mt-5 transition-colors text-sm"
            >
              Book Free Consultation <ArrowRight size={15} />
            </Link>
          </div>
        </div>
      </article>

      <section>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h2 className="font-heading font-extrabold text-2xl tracking-tight mb-8">Keep reading</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {others.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} className="group border border-border bg-white hover-lift block p-6">
                <span className="text-xs font-bold uppercase tracking-widest text-[#FF5A00]">{p.category}</span>
                <h3 className="font-heading font-bold mt-2 leading-snug group-hover:text-[#FF5A00] transition-colors">{p.title}</h3>
                <p className="text-xs text-muted-foreground mt-3">{p.date} · {p.readTime}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
